import {
  AutocompleteInput,
  ReferenceInput,
  TextInput,
} from "react-admin";
import MuiDatePickerInput from "../../common/MuiDatePickerInput";

const inventoryAgeFilterList = (permissions) => {
  const defaultFilter = [
    <MuiDatePickerInput
      alwaysOn
      source="start_date"
      variant="outlined"
      label="mine.label.start_date"
      maxDateSource="end_date"
    />,
    <MuiDatePickerInput
      alwaysOn
      source="end_date"
      //FIXME: semua DateInput tidak bisa di tambah resettable
      // resettable
      variant="outlined"
      label="mine.label.end_date"
      minDateSource="start_date"
    />,
    <MuiDatePickerInput
      alwaysOn
      source="cut_off"
      variant="outlined"
      // label=""
    />,
    <TextInput
      alwaysOn
      source="product_code"
      variant="outlined"
      label="mine.label.code"
    />,
    <ReferenceInput
      alwaysOn
      source="size_id"
      reference="sizes"
      sort={{ field: "sizes.code", order: "ASC" }}
      // perPage={10}
    >
      <AutocompleteInput
        resettable
        optionText="name"
        variant="outlined"
        label="mine.label.size"
        filterToQuery={(searchText) => {
          if (!searchText) {
            return undefined;
          }
          return { name: searchText };
        }}
      />
    </ReferenceInput>,
    <ReferenceInput
      alwaysOn
      source="quality_id"
      reference="qualities"
      sort={{ field: "qualities.code", order: "ASC" }}
      // perPage={10}
    >
      <AutocompleteInput
        resettable
        optionText="code"
        variant="outlined"
        label="mine.label.quality"
        filterToQuery={(searchText) => {
          if (!searchText) {
            return undefined;
          }
          return { code: searchText };
        }}
      />
    </ReferenceInput>,
    <ReferenceInput
      alwaysOn
      source="name"
      reference="kinds"
      sort={{ field: "kinds.group", order: "ASC" }}
      // perPage={10}
    >
      <AutocompleteInput
        resettable
        // optionValue="created_at"
        optionText="name"
        variant="outlined"
        label="mine.label.kind"
        // filterToQuery={(search) => ({ created_at: search })}
      />
    </ReferenceInput>,
  ];
  if (permissions && permissions.update_company) {
    defaultFilter.unshift(
      // defaultFilter.splice(
      // 1,
      // 0,
      <ReferenceInput
        alwaysOn
        source="company_id"
        reference="companies"
        sort={{ field: "companies.alias", order: "ASC" }}
      >
        <AutocompleteInput
          resettable
          optionText="alias"
          variant="outlined"
          label="mine.label.company"
        />
      </ReferenceInput>
    );
  }
  return defaultFilter;
};

export default inventoryAgeFilterList;
